import { FormControl, TextField, FormControlLabel, Checkbox } from "@mui/material";
import { useMemo } from "react";
import { UseFormReturn, Controller } from "react-hook-form";

import dayjs from "dayjs";

/**
 * ResistenciaInput
 */

type ResistenciaInputProps<T extends {}> = {
  inputName: keyof T;
  checkboxName: keyof T;
  dataConcretagem: Date;
  duracaoConcretagem: { horas: number } | { dias: number };
  label: string;
  reactHookForm: UseFormReturn<T>;
};

export const ResistenciaInput = <T extends {},>({
  inputName,
  checkboxName,
  dataConcretagem,
  duracaoConcretagem,
  label,
  reactHookForm,
}: ResistenciaInputProps<T>) => {
  const dataLimite = useMemo(() => {
    if (dataConcretagem) {
      if ('horas' in duracaoConcretagem && typeof duracaoConcretagem.horas === 'number') {
        return dayjs(dataConcretagem).add(dayjs.duration({ hours: duracaoConcretagem.horas }));
      }
      if ('dias' in duracaoConcretagem && typeof duracaoConcretagem.dias === 'number') {
        return dayjs(dataConcretagem).add(dayjs.duration({ days: duracaoConcretagem.dias }));
      }
    }
    return null;
  }, [
    dataConcretagem,
    duracaoConcretagem,
  ]);

  return (
    <Controller
      name={inputName as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        const value = field.value && typeof field.value === 'string'
          ? field.value
          : '';

        let helperText: string | null = null;

        if (inputName in formState.errors) {
          const error = formState.errors[inputName] as any;
          if (typeof error.message === 'string') {
            helperText = error.message;
          }
        }

        return (
          <FormControl>
            <TextField
              size="small"
              fullWidth={true}
              error={helperText !== null && helperText !== undefined}
              helperText={helperText}
              value={value}
              onChange={e => field.onChange(e.target.value)}
            />

            <Controller
              name={checkboxName as any}
              control={reactHookForm.control}
              render={({ field: checkboxField }) => {
                const checkboxValue = checkboxField.value && typeof checkboxField.value === 'boolean'
                  ? checkboxField.value
                  : false;

                return (
                  <div className="w-full flex flex-row justify-between items-center">
                    <FormControlLabel
                      label={label}
                      sx={{ paddingLeft: '2px' }}
                      control={
                        <Checkbox
                          checked={checkboxValue}
                          onChange={e => checkboxField.onChange(e)}
                        />
                      }
                    />
                    {
                      checkboxValue &&
                      <p className="text-black dark:text-white">
                        {dataLimite && dataLimite.format("DD/MM/YYYY")}
                      </p>
                    }
                  </div>
                )
              }}
            />
          </FormControl>
        );
      }}
    />
  );
}